import moment from 'moment';
import classes from './veryNewProposalDesign.module.scss';
import { ItineraryTransfer, SortedItem, View } from '../../atom/Types';
import React from 'react';

interface props {
    singleTranferData: SortedItem
    node: View
}

const SingleTranferCard: React.FC<props> = ({ singleTranferData, node }) => {
    function isTranfer(item: SortedItem): item is ItineraryTransfer {
        return item.type === 'transfer'
    }


    return (
        <div>
            {isTranfer(singleTranferData) && singleTranferData.transferType === node.transferName ?
                <div className={classes.SingleTransferCard}>
                    <div className={classes.TransferInfo}>
                        <div className={classes.TransferTag}>{singleTranferData.transfer.providerName}</div>
                        <div className={classes.TransferName}>
                        </div>
                        <div className={classes.DepartureTime}>
                            <div className={classes.Transfersubheader}>Start Point :</div>
                            <div className={classes.TransfersubValue}>{singleTranferData.startPoint}</div>
                        </div>
                        <div className={classes.DepartureTime}>
                            <div className={classes.Transfersubheader}>Start Time :</div>
                            <div className={classes.TransfersubValue}>{moment(singleTranferData.startTime).format('LT ll')}</div>
                        </div>
                        <div className={classes.DepartureTime}>
                            <div className={classes.Transfersubheader}>Finishing Point :</div>
                            <div className={classes.TransfersubValue}>{singleTranferData.finishPoint}</div>
                        </div>
                    </div>
                </div>
                // : node.transferName === 'Private' && node?.dayTransfers?.filter((n:any)=>{ n?.transferType.includes!(node.transferName)}).length===0 ? <div className={classes.SingleTransferCardNoNeeded}><p>No Private transfer data found</p></div> :
                //    node.transferName === 'Group' && node?.dayTransfers?.filter((n:any)=>{n?.transferType.includes!(node.transferName)}).length===0  ? <div className={classes.SingleTransferCardNoNeeded}><p>No shared transfer data found</p></div> 
                : null
            }
        </div>
    )

}
export default SingleTranferCard;